export default function filterReducer(
  filterState,
  commentArr,
  currentUser,
  commentWithReplyMentions = []
) {
  switch (filterState) {
    case 'All comments':
      return commentArr;
    case 'Resolved comments':
      return commentArr.filter(comment => comment.resolved);
    case 'Open comments':
      return commentArr.filter(comment => !comment.resolved);
    case 'Mentions Me':
      // Filter comments that mention the current user or have replies that mention the user
      // AND are not resolved
      return commentArr.filter(comment => {
        // Skip resolved comments in Mentions Me filter
        if (comment.resolved) return false;

        const commentId = typeof comment.id === 'string' ? parseInt(comment.id, 10) : comment.id;

        // Check if this comment's ID is in the list of comments with reply mentions
        if (commentWithReplyMentions.includes(commentId)) {
          return true;
        }

        if (!comment.body || !currentUser || !currentUser.display) return false;

        // Check for different possible mention formats
        if (
          comment.body.includes(`**${currentUser.display}**`) ||
          comment.body.includes(currentUser.display)
        ) {
          return true;
        }

        return false;
      });
    default:
      return commentArr;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/utils/filterReducer.js